import { useEffect, useState } from 'preact/hooks';
import { effect } from '@preact/signals';
import { compareBible } from '../state/bible-store.js';
import { route } from '../state/store.js';
import { loadChapterText, type ChapterVerse } from '../audio/biblebrain.js';

/**
 * Renders the same chapter in a second translation, as a quieter
 * "Comparison · {translation}" section below the main chapter. Only
 * appears when `compareBible.value` is set via the gear menu.
 */
export function CompareChapter() {
  const [verses, setVerses] = useState<ChapterVerse[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState<string>('');

  useEffect(() => {
    let token = 0;
    const stop = effect(() => {
      const compare = compareBible.value;
      const r = route.value;
      const myToken = ++token;
      if (!compare) {
        setVerses(null);
        setLabel('');
        return;
      }
      setLabel(compare.displayName);
      setLoading(true);
      void loadChapterText(r.book, r.chapter, compare.bibleId).then((result) => {
        if (myToken !== token) return;
        setVerses(result.verses);
        setLoading(false);
      });
    });
    return stop;
  }, []);

  if (!compareBible.value) return null;

  return (
    <section class="compare-chapter" aria-label={`Comparison in ${label}`}>
      <header class="compare-chapter-header">
        <span class="compare-chapter-eyebrow">Comparison</span>
        <span class="compare-chapter-name">{label}</span>
      </header>
      {loading || !verses ? (
        <p class="compare-chapter-empty">Loading…</p>
      ) : verses.length === 0 ? (
        <p class="compare-chapter-empty">Not available in this translation.</p>
      ) : (
        <div class="compare-chapter-verses">
          {verses.map((v) => (
            <p key={v.ref} class="compare-verse">
              <sup class="verse-num">{v.number}</sup> {v.text}
            </p>
          ))}
        </div>
      )}
    </section>
  );
}
